<template>
  <div class="content-wrapper" :class="{ 'loading-opacity': preloader }">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Evaluación de Desempeño"
          directory="Solicitar Evaluación"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-12">
    <app-overlay-loader v-if="preloader" />
      <form
        ref="form"
        data-url="/performance-evaluations/reviewer-evaluator/store"
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
      >
        <legend class="text-primary my-3">
          <h5>Seleccionar Evaluadores</h5>
        </legend>
        <table class="table table-sm table-striped" v-if="evaluators && evaluators.length > 0">
          <thead>
            <tr>
              <th scope="col" class="align-middle">Nombre</th>
              <th scope="col" class="align-middle">Cargo</th>
              <th scope="col" class="align-middle">Solicitar evaluación</th>
              <th scope="col" class="align-middle">Estado evaluación</th>
              <th scope="col" class="align-middle">Días</th>
              <th scope="col" class="align-middle">Notificar</th>
              <th scope="col" class="align-middle">Documento</th>
            </tr>
          </thead>
          <tbody>
                <tr v-for="(value, key) in evaluators" :key="key">
                  <td class="align-middle">
                    {{
                      value.evaluator 
                      ? `${value.evaluator.first_name} ${value.evaluator.last_name}`
                      : ""
                    }}
                  </td>
                  <td>
                    {{
                      value.evaluator_type
                      ? `${value.evaluator_type.value}`
                      : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <input
                      type="checkbox"
                      v-model="value.is_performance"
                    />
                  </td>
                  <td class="align-middle text-center">
                    <span v-if="value.is_performance && value.evaluation_team_performance" class="badge badge-sm badge-pill badge-success">Cargado</span>
                    <span v-if="value.is_performance && !value.evaluation_team_performance" class="badge badge-sm badge-pill badge-warning">Pendiente</span>
                  </td>
                  <td class="align-middle text-center">
                    <span v-if="value.performance_time && value.performance_time.remaining_days > 0 && value.performance_time.remaining_days <=2" :class="`badge badge-sm badge-pill badge-warning`">
                    {{
                      value.performance_time
                      ? value.performance_time.remaining_days
                      : ``
                    }}
                    </span>
                    <span v-if="value.performance_time && value.performance_time.remaining_days > 2" :class="`badge badge-sm badge-pill badge-success`">
                    {{
                      value.performance_time
                      ? value.performance_time.remaining_days
                      : ``
                    }}
                    </span>
                    <span v-if="value.performance_time && value.performance_time.remaining_days <= 0" :class="`badge badge-sm badge-pill badge-danger`">
                    {{
                      value.performance_time
                      ? value.performance_time.remaining_days
                      : ``
                    }}
                    </span>
                  </td>
                  <td class="align-middle text-center">
                    <switches theme="bootstrap" color="primary" :label="`${value.is_notify ? 'On' : 'Off'}`" v-model="value.is_notify"></switches>
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="button"
                      class="btn btn-primary mr-2 mb-2"
                      @click="openModalEvaluation(value.id, value.evaluator_type.value, value.is_performance)"
                    >
                      <app-icon name="external-link" />
                    </button>
                  </td>
                </tr>
          </tbody>
        </table>
        <div class="mt-5">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
          <button
            type="submit"
            class="btn btn-warning mr-2"
            @click.prevent="openConfirmationModal"
          >
            Notificar
          </button>
        </div>
      </form>
    </div>
    <performance-evaluation-modal 
      v-if="isAddEditModalEvaluationActive"
      :id-evaluator="id_evaluator"
      :type-evaluator="type_evaluator"
      @close-modal="closeModalEvaluation"
      modalTitle="Evaluación de desempeño"
    />

    <app-confirmation-modal
      v-if="confirmationModalActive"
      :preloader="preloader"
      modal-id="modal-confirm-id"
      @confirmed="notifyPerformance"
      @cancelled="cancelledNotify"
      title="Notificación"
      message="Previamente debe guardar los cambios. ¿Desea procesar la notificacón?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
    
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "@/app/helpers/AxiosHelper";
import Switches from 'vue-switches';
export default {
  extends: CoreLibrary,
  mixins: [FormMixin],
  components: {
        Switches
    },
props: {
    evalTestId: String
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      evaluators: {},
      isAddEditModalEvaluationActive: "",
      id_evaluator: null,
      type_evaluator: "",
      dateNow: new Date(),
      label_day: '',
      confirmationModalActive: false,
    };
  },
  created() {
    this.data();
  },
  methods: {
    submit() {
      for (let index = 0; index < this.evaluators.length; index++) {
        this.evaluators[index].is_performance = this.evaluators[index].is_performance ? 1 : 0;
        this.evaluators[index].is_notify = this.evaluators[index].is_notify ? 1 : 0;
      }
      for (let indexj = 0; indexj < this.evaluators.length; indexj++) {
        if(this.evaluators[indexj].is_notify && !this.evaluators[indexj].is_performance) {
            this.$toastr.e(
              "Para notificar se necesita Solicitar evaluación"
            );
            return;
        }
      }
      this.save(this.evaluators);
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("created_success"));
      this.data();
    },
    data() {
      this.preloader = true;
      let url = `/performance-evaluations/reviewer-evaluator/showTeam/${this.evalTestId}`;
      this.axiosGet(url).then((response) => {
        this.evaluators = response.data;
      }).catch(({ error }) => {
        console.log(error);
      })
      .finally(() => {
        this.preloader = false;
      });
    },
    openModalEvaluation(id, type, is_performance) {
      if(!is_performance) {
        this.$toastr.e(
              "Necesita Solicitar evaluación"
            );
            return;
      }
      this.id_evaluator = id;
      this.type_evaluator = type;
      this.isAddEditModalEvaluationActive = true;
    },
    closeModalEvaluation() {
      $("#modal-evaluation-edit").modal("hide");
      this.data();
      this.isAddEditModalEvaluationActive = false;
    },
    notifyPerformance(){
      this.preloader = true;
      const url = `/performance-evaluations/reviewer-evaluator/sendNotify`;
        axiosPost(url, this.evaluators)
          .then(( res ) => {
            if (res.status == 200) {
            this.$toastr.s("Notificaciones enviadas");
          } else {
            this.$toastr.s("Error");
          }
          })
          .catch(({ error }) => {
          })
          .finally(() => {
            this.preloader = false;
          });
    },
    daysPerformance(item) {

      // if (moment(this.dateNow).format() < moment(item).add(5,'days').format()) {
      if(item) {
        // const days = moment(item).add(5,'days').diff(moment(this.dateNow), 'days');
        const days = item;
        if (days >= 0 && days <= 2){
          this.label_day = 'warning';
        } else if (days > 2) {
          this.label_day = 'success';
        } else if (days < 0) {
          this.label_day = 'danger';
        } 
        return days;
      } 
    },
    returnPage() {
      window.location.href = `/performance-evaluations/reviewer-evaluator`;
    },
    openConfirmationModal() {
      this.confirmationModalActive = true;
    },
    cancelledNotify() {
      this.confirmationModalActive = false;
    },
  },
}
</script>

<style>

</style>